// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   Brush,
// } from "recharts";
// import { useHistory } from "react-router-dom";
// import "./Custom.css";
// import "../loader.css";

// export default function PortalCharStats() {
//   const [portals, setPortals] = useState([]);
//   const [selectedPortal, setSelectedPortal] = useState("");
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isInitialLoading, setIsInitialLoading] = useState(true);
//   const [portalName, setPortalName] = useState("");
//   const [totalCharacters, setTotalCharacters] = useState(0);
//   const [averagePerDay, setAveragePerDay] = useState(0);

//   const navigate = useHistory();

//   // Fetch portals only once on mount
//   useEffect(() => {
//     const fetchPortals = async () => {
//       setIsInitialLoading(true);
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`);
//         setPortals(res.data || []);
//       } catch (error) {
//         console.error("Error fetching portals:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Failed",
//           text: "Could not load portals.",
//           confirmButtonText: "Ok",
//         });
//       } finally {
//         setIsInitialLoading(false);
//       }
//     };
//     fetchPortals();
//   }, []); // Empty dependency array - runs only once

//   // Fetch character data
//   const fetchCharData = async () => {
//     if (!selectedPortal || !startDate || !endDate) {
//       Swal.fire({
//         icon: "warning",
//         title: "Missing Input",
//         text: "Please select a portal and date range.",
//         confirmButtonText: "Ok",
//       });
//       return;
//     }

//     setLoading(true);
//     const start = startDate.toISOString().split("T")[0];
//     const end = endDate.toISOString().split("T")[0];

//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/GetPortalCharCountsByDateRange?portalId=${selectedPortal}&startDate=${start}&endDate=${end}`
//       );

//       const records = res.data?.records || [];
//       const averagePerDay = res.data?.averagePerDay ?? 0;
//       const parsedData = records.map((r) => ({
//         date: new Date(r.date).toLocaleDateString("en-US", {
//           month: "2-digit",
//           day: "2-digit",
//           year: "numeric",
//         }),
//         question: r.questionCharacters ?? 0,
//         response: r.responseCharacters ?? 0,
//         average: averagePerDay  // Same value for all days
//       }));
//       setChartData(parsedData);
//       setTotalCharacters(res.data?.totalCharacters ?? 0);
//       setAveragePerDay(res.data?.averagePerDay ?? 0);

//       const p = portals.find((p) => p.id === Number(selectedPortal));
//       setPortalName(p?.portal_Name || "");
//     } catch (error) {
//       console.error("Error fetching chart data:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Failed",
//         text: "Could not load character data.",
//         confirmButtonText: "Ok",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const BackFunc = () => navigate.push("/index");

//   return (
//     <div className="page-content-wrapper">
//       {isInitialLoading ? (
//         <div className="page-content d-flex justify-content-center align-items-center">
//           <div className="my-wrapper">
//             <div className="spinner center">
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//               <div className="spinner-blade" />
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="page-content">
//           {/* Page Header */}
//           <div className="page-bar">
//             <div className="page-title-breadcrumb">
//               <div className="pull-left">
//                 <div className="page-title my-0">Portal Character Usage Statistics</div>
//               </div>
//             </div>
//             <div className="page-title-breadcrumb">
//               <div className="pull-right">
//                 <button
//                   type="button"
//                   className="btn d-inline-block"
//                   style={{
//                     backgroundColor: "#1e2b38",
//                     color: "#FFF",
//                     border: "1px solid #1e2b38",
//                   }}
//                   onClick={BackFunc}
//                 >
//                   <i className="fa fa-arrow-left" aria-hidden="true" />
//                 </button>
//               </div>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-md-12">
//               <div className="card">
//                 {/* Filter Section */}
//                 <div className="card-head">
//                   <header>
//                     <div className="row g-3 align-items-end">
//                       <div className="col-md-4">
//                         <label className="form-label">Select Portal</label>
//                         <select
//                           className="form-control"
//                           value={selectedPortal}
//                           onChange={(e) => setSelectedPortal(e.target.value)}
//                         >
//                           <option value="">-- Choose Portal --</option>
//                           {portals
//                             .filter((p) => p.active_Status !== false)
//                             .map((p) => (
//                               <option key={p.id} value={p.id}>
//                                 {p.portal_Name}
//                               </option>
//                             ))}
//                         </select>
//                       </div>

//                       <div className="col-md-3">
//                         <label className="form-label">Start Date</label>
//                         <DatePicker
//                           selected={startDate}
//                           onChange={(date) => setStartDate(date)}
//                           className="form-control"
//                           dateFormat="MM/dd/yyyy"
//                           placeholderText="Select start date"
//                         />
//                       </div>

//                       <div className="col-md-3">
//                         <label className="form-label">End Date</label>
//                         <DatePicker
//                           selected={endDate}
//                           onChange={(date) => setEndDate(date)}
//                           className="form-control"
//                           dateFormat="MM/dd/yyyy"
//                           placeholderText="Select end date"
//                         />
//                       </div>

//                       <div className="col-md-2">
//                         <button
//                           type="button"
//                           className="btn w-100"
//                           style={{
//                             backgroundColor: "#1e2b38",
//                             color: "#FFF",
//                             border: "1px solid #1e2b38",
//                           }}
//                           onClick={fetchCharData}
//                           disabled={loading}
//                         >
//                           {loading ? (
//                             <>
//                               <i className="fa fa-spinner fa-spin" /> Loading...
//                             </>
//                           ) : (
//                             <>
//                               <i className="fa fa-search" /> Load Data
//                             </>
//                           )}
//                         </button>
//                       </div>
//                     </div>
//                   </header>
//                 </div>

//                 <div className="card-body">
//                   {/* Chart Section */}
//                   {loading ? (
//                     <div className="text-center mt-5 mb-5">
//                       <div className="my-wrapper">
//                         <div className="spinner center">
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                           <div className="spinner-blade" />
//                         </div>
//                       </div>
//                     </div>
//                   ) : chartData.length > 0 ? (
//                     <>
//                       {/* Graph */}
//                       <div className="mb-4">
//                         <h5 className="mb-3">
//                           {portalName} — Character Counts ({chartData[0]?.date ?? "--"} to{" "}
//                           {chartData[chartData.length - 1]?.date ?? "--"})
//                         </h5>

//                         {/* Stats Card */}
//                         <div className="stats-card">
//                           <h6>📊 Summary</h6>
//                           <div className="stat-row">
//                             <span className="stat-label">Days:</span>
//                             <span className="stat-value">{chartData.length}</span>
//                           </div>
//                           <div className="stat-row">
//                             <span className="stat-label">Total Usage:</span>
//                             <span className="stat-value">{totalCharacters?.toLocaleString() ?? 0}</span>
//                           </div>
//                           <div className="stat-row">
//                             <span className="stat-label">Avg per Day:</span>
//                             <span className="stat-value">{averagePerDay?.toLocaleString(undefined, { maximumFractionDigits: 2 }) ?? 0}</span>
//                           </div>
//                         </div>
//                         <ResponsiveContainer width="100%" height={400}>
//                           <LineChart
//                             data={chartData}
//                             margin={{ top: 20, right: 40, left: 0, bottom: 0 }}
//                           >
//                             <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//                             <XAxis dataKey="date" stroke="#666" />
//                             <YAxis stroke="#666" />
//                             <Tooltip
//                               contentStyle={{
//                                 backgroundColor: "#fff",
//                                 border: "1px solid #ccc",
//                               }}
//                             />
//                             <Legend />
//                             <Line
//                               type="monotone"
//                               dataKey="question"
//                               stroke="#42a5f5"
//                               strokeWidth={2}
//                               name="Question Characters"
//                               dot={false}
//                             />
//                             <Line
//                               type="monotone"
//                               dataKey="response"
//                               stroke="#66bb6a"
//                               strokeWidth={2}
//                               name="Response Characters"
//                               dot={false}
//                             />
//                             <Line
//                               type="monotone"
//                               dataKey="average"
//                               stroke="#ffca28"
//                               strokeWidth={2}
//                               name="Average Characters"
//                               dot={false}
//                             />
//                             <Brush dataKey="date" height={30} stroke="#8884d8" />
//                           </LineChart>
//                         </ResponsiveContainer>
//                       </div>

//                       {/* Table */}
//                       <div className="table-responsive">
//                         <table className="table table-striped custom-table table-hover">
//                           <thead>
//                             <tr>
//                               <th style={{ width: "5%" }}>Sl.</th>
//                               <th style={{ width: "20%" }}>Date</th>
//                               <th style={{ width: "25%" }}>Question Characters</th>
//                               <th style={{ width: "25%" }}>Response Characters</th>
//                               <th style={{ width: "25%" }}>Total Characters</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {chartData.map((d, i) => (
//                               <tr key={i}>
//                                 <td className="text-left">{i + 1}</td>
//                                 <td className="text-left">{d.date}</td>
//                                 <td className="text-left">
//                                   {(d.question ?? 0).toLocaleString()}
//                                 </td>
//                                 <td className="text-left">
//                                   {(d.response ?? 0).toLocaleString()}
//                                 </td>
//                                 <td className="text-left">
//                                   {((d.question ?? 0) + (d.response ?? 0)).toLocaleString()}
//                                 </td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </>
//                   ) : (
//                     <div className="text-center mt-5 mb-5">
//                       <i className="fa fa-chart-line fa-3x" style={{ color: "#ccc" }} />
//                       <p className="mt-3" style={{ color: "#999" }}>
//                         No data to display. Select portal and date range above.
//                       </p>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Brush,
} from "recharts";
import { useHistory } from "react-router-dom";
import "./Custom.css";
import "../loader.css";

export default function PortalCharStats() {
  const [portals, setPortals] = useState([]);
  const [selectedPortal, setSelectedPortal] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [portalName, setPortalName] = useState("");
  const [totalCharacters, setTotalCharacters] = useState(0);
  const [averagePerDay, setAveragePerDay] = useState(0);
  const [isManager, setIsManager] = useState(false);

  const navigate = useHistory();

  // Check if user is manager and get their portal
  useEffect(() => {
    const managerPortalId = localStorage.getItem("MPortalId");
    if (managerPortalId) {
      setIsManager(true);
      setSelectedPortal(managerPortalId);
    }
  }, []);

  // Fetch portals only once on mount
  useEffect(() => {
    const fetchPortals = async () => {
      setIsInitialLoading(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`);
        setPortals(res.data || []);
        
        // If manager, set the portal name immediately
        if (isManager && selectedPortal) {
          const portal = (res.data || []).find((p) => p.id === Number(selectedPortal));
          if (portal) {
            setPortalName(portal.portal_Name);
          }
        }
      } catch (error) {
        console.error("Error fetching portals:", error);
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Could not load portals.",
          confirmButtonText: "Ok",
        });
      } finally {
        setIsInitialLoading(false);
      }
    };
    fetchPortals();
  }, [isManager, selectedPortal]);

  // Fetch character data
  const fetchCharData = async () => {
    if (!selectedPortal || !startDate || !endDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Input",
        text: "Please select a portal and date range.",
        confirmButtonText: "Ok",
      });
      return;
    }

    setLoading(true);
    const start = startDate.toISOString().split("T")[0];
    const end = endDate.toISOString().split("T")[0];

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/GetPortalCharCountsByDateRange?portalId=${selectedPortal}&startDate=${start}&endDate=${end}`
      );

      const records = res.data?.records || [];
      const averagePerDay = res.data?.averagePerDay ?? 0;
      const parsedData = records.map((r) => ({
        date: new Date(r.date).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        }),
        question: r.questionCharacters ?? 0,
        response: r.responseCharacters ?? 0,
        average: averagePerDay
      }));
      setChartData(parsedData);
      setTotalCharacters(res.data?.totalCharacters ?? 0);
      setAveragePerDay(res.data?.averagePerDay ?? 0);

      const p = portals.find((p) => p.id === Number(selectedPortal));
      setPortalName(p?.portal_Name || "");
    } catch (error) {
      console.error("Error fetching chart data:", error);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Could not load character data.",
        confirmButtonText: "Ok",
      });
    } finally {
      setLoading(false);
    }
  };

  const BackFunc = () => navigate.push("/index");

  return (
    <div className="page-content-wrapper">
      {isInitialLoading ? (
        <div className="page-content d-flex justify-content-center align-items-center">
          <div className="my-wrapper">
            <div className="spinner center">
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
              <div className="spinner-blade" />
            </div>
          </div>
        </div>
      ) : (
        <div className="page-content">
          {/* Page Header */}
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className="pull-left">
                <div className="page-title my-0">Portal Character Usage Statistics</div>
              </div>
            </div>
            <div className="page-title-breadcrumb">
              <div className="pull-right">
                <button
                  type="button"
                  className="btn d-inline-block"
                  style={{
                    backgroundColor: "#1e2b38",
                    color: "#FFF",
                    border: "1px solid #1e2b38",
                  }}
                  onClick={BackFunc}
                >
                  <i className="fa fa-arrow-left" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                {/* Filter Section */}
                <div className="card-head">
                  <header>
                    <div className="row g-3 align-items-end">
                      <div className="col-md-4">
                        <label className="form-label">
                          Select Portal
                          {isManager && (
                            <span className="badge bg-info ms-2" style={{ fontSize: "0.7em" }}>
                              Manager View
                            </span>
                          )}
                        </label>
                        <select
                          className="form-control"
                          value={selectedPortal}
                          onChange={(e) => setSelectedPortal(e.target.value)}
                          disabled={isManager}
                          style={isManager ? {
                            backgroundColor: "#f5f5f5",
                            cursor: "not-allowed",
                            opacity: 0.7
                          } : {}}
                        >
                          <option value="">-- Choose Portal --</option>
                          {portals
                            .filter((p) => p.active_Status !== false)
                            .map((p) => (
                              <option key={p.id} value={p.id}>
                                {p.portal_Name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Start Date</label>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          className="form-control"
                          dateFormat="MM/dd/yyyy"
                          placeholderText="Select start date"
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">End Date</label>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control"
                          dateFormat="MM/dd/yyyy"
                          placeholderText="Select end date"
                        />
                      </div>

                      <div className="col-md-2">
                        <button
                          type="button"
                          className="btn w-100"
                          style={{
                            backgroundColor: "#1e2b38",
                            color: "#FFF",
                            border: "1px solid #1e2b38",
                          }}
                          onClick={fetchCharData}
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" /> Loading...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-search" /> Load Data
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </header>
                </div>

                <div className="card-body">
                  {/* Chart Section */}
                  {loading ? (
                    <div className="text-center mt-5 mb-5">
                      <div className="my-wrapper">
                        <div className="spinner center">
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                          <div className="spinner-blade" />
                        </div>
                      </div>
                    </div>
                  ) : chartData.length > 0 ? (
                    <>
                      {/* Graph */}
                      <div className="mb-4">
                        <h5 className="mb-3">
                          {portalName} — Character Counts ({chartData[0]?.date ?? "--"} to{" "}
                          {chartData[chartData.length - 1]?.date ?? "--"})
                        </h5>

                        {/* Stats Card */}
                        <div className="stats-card">
                          <h6>📊 Summary</h6>
                          <div className="stat-row">
                            <span className="stat-label">Days:</span>
                            <span className="stat-value">{chartData.length}</span>
                          </div>
                          <div className="stat-row">
                            <span className="stat-label">Total Usage:</span>
                            <span className="stat-value">{totalCharacters?.toLocaleString() ?? 0}</span>
                          </div>
                          <div className="stat-row">
                            <span className="stat-label">Avg per Day:</span>
                            <span className="stat-value">{averagePerDay?.toLocaleString(undefined, { maximumFractionDigits: 2 }) ?? 0}</span>
                          </div>
                        </div>
                        <ResponsiveContainer width="100%" height={400}>
                          <LineChart
                            data={chartData}
                            margin={{ top: 20, right: 40, left: 0, bottom: 0 }}
                          >
                            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                            <XAxis dataKey="date" stroke="#666" />
                            <YAxis stroke="#666" />
                            <Tooltip
                              contentStyle={{
                                backgroundColor: "#fff",
                                border: "1px solid #ccc",
                              }}
                            />
                            <Legend />
                            <Line
                              type="monotone"
                              dataKey="question"
                              stroke="#42a5f5"
                              strokeWidth={2}
                              name="Question Characters"
                              dot={false}
                            />
                            <Line
                              type="monotone"
                              dataKey="response"
                              stroke="#66bb6a"
                              strokeWidth={2}
                              name="Response Characters"
                              dot={false}
                            />
                            <Line
                              type="monotone"
                              dataKey="average"
                              stroke="#ffca28"
                              strokeWidth={2}
                              name="Average Characters"
                              dot={false}
                            />
                            <Brush dataKey="date" height={30} stroke="#8884d8" />
                          </LineChart>
                        </ResponsiveContainer>
                      </div>

                      {/* Table */}
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              <th style={{ width: "5%" }}>Sl.</th>
                              <th style={{ width: "20%" }}>Date</th>
                              <th style={{ width: "25%" }}>Question Characters</th>
                              <th style={{ width: "25%" }}>Response Characters</th>
                              <th style={{ width: "25%" }}>Total Characters</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chartData.map((d, i) => (
                              <tr key={i}>
                                <td className="text-left">{i + 1}</td>
                                <td className="text-left">{d.date}</td>
                                <td className="text-left">
                                  {(d.question ?? 0).toLocaleString()}
                                </td>
                                <td className="text-left">
                                  {(d.response ?? 0).toLocaleString()}
                                </td>
                                <td className="text-left">
                                  {((d.question ?? 0) + (d.response ?? 0)).toLocaleString()}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <div className="text-center mt-5 mb-5">
                      <i className="fa fa-chart-line fa-3x" style={{ color: "#ccc" }} />
                      <p className="mt-3" style={{ color: "#999" }}>
                        No data to display. Select portal and date range above.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}